import { render, staticRenderFns } from "./reactionMod.vue?vue&type=template&id=732080f8&scoped=true&"
import script from "./reactionMod.vue?vue&type=script&lang=js&"
export * from "./reactionMod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732080f8",
  null
  
)

export default component.exports